import * as React from 'react';
/**
 *
 * Original name: upload
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=46273%3A50
 *
 */
export const UploadPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M29.996 9.514v.007c-.734 3.84-4.791 12.18-14.684 15.636l1.32 3.776c6.303-2.203 10.606-6.11 13.364-10.004V45.99h4V18.923c2.758 3.896 7.061 7.806 13.368 10.01l1.32-3.776C38.79 21.7 34.734 13.36 34 9.52h-.004v-.007h-4ZM8 54.524h48v-4H8v4Z", fill: "currentColor" })));
